import defaultApiClient, { tryCatch } from '@/services/api-client';
import {
  AuthResponse,
  UserProfile,
  UpdateUserPasswordPayload,
} from './auth.type';
import { persistStorageService } from './persist-storage';

export const getMe = async () => {
  const { data: response, error } = await tryCatch(
    defaultApiClient.get<{
      status: 'success' | 'error';
      user: UserProfile;
    }>(`/api/v1/auth/me`),
  );

  if (error) {
    console.log('error getMe', error);
    throw error;
  }

  return response.data;
};

export const refreshToken = async () => {
  console.log('Calling refreshToken');
  const token = persistStorageService.getPersistItem<string>({
    name: 'token',
  });

  const refreshToken = persistStorageService.getPersistItem<string>({
    name: 'refresh_token',
  });

  const { data: response, error } = await tryCatch(
    defaultApiClient.post<AuthResponse>(`/api/v1/auth/validate_token`, {
      access_token: token,
      refresh_token: refreshToken,
    }),
  );

  if (error) {
    console.log('error refreshToken', error);
    persistStorageService.batchRemovePersistItems({
      names: ['token', 'refresh_token', 'user', 'expires_at'],
    });

    return null;
  }

  if (response.status !== 200) {
    console.log('error refreshToken, clearing storage', response.status);
    persistStorageService.batchRemovePersistItems({
      names: ['token', 'refresh_token', 'user', 'expires_at'],
    });
    return null;
  }

  if (response.data.token) {
    console.log('success refreshToken, setting token');
    persistStorageService.setPersistItem({
      name: 'token',
      value: response.data.token,
    });
  }

  if (response.data.refresh_token) {
    persistStorageService.setPersistItem({
      name: 'refresh_token',
      value: response.data.refresh_token,
    });
  }

  if (response.data.expires_at) {
    persistStorageService.setPersistItem({
      name: 'expires_at',
      value: response.data.expires_at.toString(),
      stringify: true,
    });
  }

  if (response.data.user) {
    persistStorageService.setPersistItem({
      name: 'user',
      value: JSON.stringify(response.data.user),
    });
  }

  if (response.data.user) {
    persistStorageService.setPersistItem({
      name: 'user',
      value: JSON.stringify(response.data.user),
    });
  }

  return response.data;
};

// Update user password (for completing signup after invitation)
export const updateUserPassword = async (
  payload: UpdateUserPasswordPayload,
): Promise<UserProfile> => {
  const { data: response, error } = await tryCatch(
    defaultApiClient.put('/api/v1/auth/update_user', payload),
  );

  if (error) {
    console.log('error updateUserPassword', error);
    throw error;
  }

  return response.data;
};

export const authService = {
  refreshToken,
  getMe,
  updateUserPassword,
};
